import { Observable } from 'rxjs';
import { ManualsSearchResults } from '../../model/product.model';

export abstract class ProductModelSearchAdapter {
  abstract suggest(insertedModelMark: string): Observable<string>;

  abstract find(insertedModelMark: string): Observable<string>;

  abstract findManuals(query: string | null | undefined): Observable<ManualsSearchResults>;
}
